<form [formGroup]='utilitiesForm' id='{{formGroupName}}' (ngSubmit)='onSubmit()'>

	<div class='step-title service-title' i18n>Set up your Utilities for free</div>

	<!-- Probably assuming we only ask this question for the UK-->
	<div class='step-description' i18n>Would you be interested in free utility support that could help you save up to £396 a year on your bills?</div>
	
	<!-- Utilities Form Content -->
	<div class='utilities-fields'>
		<div class='form-control input-no-label'>
			<label i18n>Destination Address</label>
			<mat-form-field class="full-width no-label-field">
				<input matInput formControlName='destinationAddress' placeholder='Enter your address' i18n-placeholder />
			</mat-form-field>
		</div>

		<div class='form-control input-no-label'>
			<label i18n>Destination Postcode</label>
			<mat-form-field class="full-width">
				<input matInput formControlName='destinationPostcode' placeholder='Enter your postcode' i18n-placeholder />
			</mat-form-field>
		</div>

		<div class='section-title' i18n>Compare Broadband/cable plans?</div>

		<div class='form-control'>
			<mat-radio-group formControlName='comparePlans' aria-label='Select an option' class='custom-radio-group'>
				<mat-radio-button value='yes'>
					<div class='option'>
						<div class='option-name' i18n='@@optionYes'>Yes</div>
					</div>
				</mat-radio-button>
				<mat-radio-button value='no'>
					<div class='option'>
						<div class='option-name' i18n='@@optionNo'>No</div>
					</div>
				</mat-radio-button>
			</mat-radio-group>
		</div>
	</div>

	<!-- Mobile Navigation Buttons -->
	<div class='step-footer step-footer-center'>
		<div class='step-footer-buttons'>
			<button class='back' type='button' (click)='formService.backThirdParty()'>
				<mat-icon svgIcon='icons:chevron-left'></mat-icon>
				<ng-container i18n='@@buttonBack'>Back</ng-container>
			</button>
			<button class='submit' type='submit'>
				<ng-container *ngIf='formService.isLastThirdPartyStep()' i18n='buttonSaveSelection'>Save</ng-container>
				<ng-container *ngIf='!formService.isLastThirdPartyStep()' i18n='@@buttonContinue'>Continue</ng-container>
				<mat-icon svgIcon='icons:chevron-right'></mat-icon>
			</button>
		</div>
	</div>
</form>